import element from 'ember-element-helper/helpers/element';
import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';
import type { TOC } from '@ember/component/template-only';

interface BoxItemSignature {
  Args: {
    disabled?: boolean;
    error?: boolean;
    selected?: boolean;
    selectable?: boolean;
    tagName?: HTMLElement['tagName'];
  };
  Blocks: {
    default: [];
  };
  Element: Element;
}

const BoxItemComponent: TOC<BoxItemSignature> = <template>
  {{#let (element (orElse @tagName 'div')) as |Element|}}
    <Element
      class={{classNames
        'box-item'
        (if @selectable 'box-item--selectable')
        (if @selected 'box-item--selected')
        (if @error 'box-item--error')
        (if @disabled 'box-item--disabled')
      }}
      disabled={{@disabled}}
      ...attributes
    >
      {{yield}}
    </Element>
  {{/let}}
</template>;

export default BoxItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BoxItem: typeof BoxItemComponent;
    'box-item': typeof BoxItemComponent;
  }
}
